import React from 'react';
import ReactDOM from 'react-dom/client';
import { StoreProvider, store } from '@link/metro-toei-pass/stores';
import '@link/metro-toei-pass/i18n';
import '@link/metro-toei-pass/styles/index.css';
import App from '@link/metro-toei-pass/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
